<dojo-icon [icon]="state.icon" />
